// @ts-check
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $e5ed8027d647799b$var$t;
const $e5ed8027d647799b$var$i = globalThis.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = `lit$${(Math.random() + "").slice(9)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$e, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$l = document, $e5ed8027d647799b$var$h = (t = "")=>$e5ed8027d647799b$var$l.createComment(t), $e5ed8027d647799b$var$r = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$d = Array.isArray, $e5ed8027d647799b$var$u = (t)=>{
    var i;
    return $e5ed8027d647799b$var$d(t) || "function" == typeof (null === (i = t) || void 0 === i ? void 0 : i[Symbol.iterator]);
}, $e5ed8027d647799b$var$c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$a = />/g, $e5ed8027d647799b$var$f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, $e5ed8027d647799b$var$_ = /'/g, $e5ed8027d647799b$var$m = /"/g, $e5ed8027d647799b$var$g = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$p = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$p(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$p(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$T = new WeakMap, $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $e5ed8027d647799b$var$N(i.insertBefore($e5ed8027d647799b$var$h(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
}, $e5ed8027d647799b$var$A = $e5ed8027d647799b$var$l.createTreeWalker($e5ed8027d647799b$var$l, 129, null, !1), $e5ed8027d647799b$var$C = (t, i)=>{
    const o = t.length - 1, l = [];
    let h, r = 2 === i ? "<svg>" : "", d = $e5ed8027d647799b$var$c;
    for(let i = 0; i < o; i++){
        const s = t[i];
        let o, u, p = -1, $ = 0;
        for(; $ < s.length && (d.lastIndex = $, u = d.exec(s), null !== u);)$ = d.lastIndex, d === $e5ed8027d647799b$var$c ? "!--" === u[1] ? d = $e5ed8027d647799b$var$v : void 0 !== u[1] ? d = $e5ed8027d647799b$var$a : void 0 !== u[2] ? ($e5ed8027d647799b$var$g.test(u[2]) && (h = RegExp("</" + u[2], "g")), d = $e5ed8027d647799b$var$f) : void 0 !== u[3] && (d = $e5ed8027d647799b$var$f) : d === $e5ed8027d647799b$var$f ? ">" === u[0] ? (d = null != h ? h : $e5ed8027d647799b$var$c, p = -1) : void 0 === u[1] ? p = -2 : (p = d.lastIndex - u[2].length, o = u[1], d = void 0 === u[3] ? $e5ed8027d647799b$var$f : '"' === u[3] ? $e5ed8027d647799b$var$m : $e5ed8027d647799b$var$_) : d === $e5ed8027d647799b$var$m || d === $e5ed8027d647799b$var$_ ? d = $e5ed8027d647799b$var$f : d === $e5ed8027d647799b$var$v || d === $e5ed8027d647799b$var$a ? d = $e5ed8027d647799b$var$c : (d = $e5ed8027d647799b$var$f, h = void 0);
        const y = d === $e5ed8027d647799b$var$f && t[i + 1].startsWith("/>") ? " " : "";
        r += d === $e5ed8027d647799b$var$c ? s + $e5ed8027d647799b$var$n : p >= 0 ? (l.push(o), s.slice(0, p) + "$lit$" + s.slice(p) + $e5ed8027d647799b$var$e + y) : s + $e5ed8027d647799b$var$e + (-2 === p ? (l.push(void 0), i) : y);
    }
    const u = r + (t[o] || "<?>") + (2 === i ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(u) : u,
        l
    ];
};
class $e5ed8027d647799b$var$E {
    constructor({ strings: t, _$litType$: s }, n){
        let l;
        this.parts = [];
        let r = 0, d = 0;
        const u = t.length - 1, c = this.parts, [v, a] = $e5ed8027d647799b$var$C(t, s);
        if (this.el = $e5ed8027d647799b$var$E.createElement(v, n), $e5ed8027d647799b$var$A.currentNode = this.el.content, 2 === s) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (l = $e5ed8027d647799b$var$A.nextNode()) && c.length < u;){
            if (1 === l.nodeType) {
                if (l.hasAttributes()) {
                    const t = [];
                    for (const i of l.getAttributeNames())if (i.endsWith("$lit$") || i.startsWith($e5ed8027d647799b$var$e)) {
                        const s = a[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = l.getAttribute(s.toLowerCase() + "$lit$").split($e5ed8027d647799b$var$e), i = /([.?@])?(.*)/.exec(s);
                            c.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $e5ed8027d647799b$var$M : "?" === i[1] ? $e5ed8027d647799b$var$H : "@" === i[1] ? $e5ed8027d647799b$var$I : $e5ed8027d647799b$var$S
                            });
                        } else c.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)l.removeAttribute(i);
                }
                if ($e5ed8027d647799b$var$g.test(l.tagName)) {
                    const t = l.textContent.split($e5ed8027d647799b$var$e), s = t.length - 1;
                    if (s > 0) {
                        l.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)l.append(t[i], $e5ed8027d647799b$var$h()), $e5ed8027d647799b$var$A.nextNode(), c.push({
                            type: 2,
                            index: ++r
                        });
                        l.append(t[s], $e5ed8027d647799b$var$h());
                    }
                }
            } else if (8 === l.nodeType) {
                if (l.data === $e5ed8027d647799b$var$o) c.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = l.data.indexOf($e5ed8027d647799b$var$e, t + 1));)c.push({
                        type: 7,
                        index: r
                    }), t += $e5ed8027d647799b$var$e.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$P(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let d = void 0 !== e ? null === (o = s._$Cl) || void 0 === o ? void 0 : o[e] : s._$Cu;
    const u = $e5ed8027d647799b$var$r(i) ? void 0 : i._$litDirective$;
    return (null == d ? void 0 : d.constructor) !== u && (null === (n = null == d ? void 0 : d._$AO) || void 0 === n || n.call(d, !1), void 0 === u ? d = void 0 : (d = new u(t), d._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Cl) && void 0 !== l ? l : h._$Cl = [])[e] = d : s._$Cu = d), void 0 !== d && (i = $e5ed8027d647799b$var$P(t, d._$AS(t, i.values), d, e)), i;
}
class $e5ed8027d647799b$var$V {
    constructor(t, i){
        this.v = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    p(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $e5ed8027d647799b$var$l).importNode(s, !0);
        $e5ed8027d647799b$var$A.currentNode = o;
        let n = $e5ed8027d647799b$var$A.nextNode(), h = 0, r = 0, d = e[0];
        for(; void 0 !== d;){
            if (h === d.index) {
                let i;
                2 === d.type ? i = new $e5ed8027d647799b$var$N(n, n.nextSibling, this, t) : 1 === d.type ? i = new d.ctor(n, d.name, d.strings, this, t) : 6 === d.type && (i = new $e5ed8027d647799b$var$L(n, this, t)), this.v.push(i), d = e[++r];
            }
            h !== (null == d ? void 0 : d.index) && (n = $e5ed8027d647799b$var$A.nextNode(), h++);
        }
        return o;
    }
    m(t) {
        let i = 0;
        for (const s of this.v)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$N {
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cg = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cg;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$P(this, t, i), $e5ed8027d647799b$var$r(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this.$(t) : void 0 !== t._$litType$ ? this.T(t) : void 0 !== t.nodeType ? this.S(t) : $e5ed8027d647799b$var$u(t) ? this.A(t) : this.$(t);
    }
    M(t, i = this._$AB) {
        return this._$AA.parentNode.insertBefore(t, i);
    }
    S(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.M(t));
    }
    $(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$r(this._$AH) ? this._$AA.nextSibling.data = t : this.S($e5ed8027d647799b$var$l.createTextNode(t)), this._$AH = t;
    }
    T(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $e5ed8027d647799b$var$E.createElement(e.h, this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.m(s);
        else {
            const t = new $e5ed8027d647799b$var$V(o, this), i = t.p(this.options);
            t.m(s), this.S(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$T.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$T.set(t.strings, i = new $e5ed8027d647799b$var$E(t)), i;
    }
    A(t) {
        $e5ed8027d647799b$var$d(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$N(this.M($e5ed8027d647799b$var$h()), this.M($e5ed8027d647799b$var$h()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cg = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
}
class $e5ed8027d647799b$var$S {
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $e5ed8027d647799b$var$P(this, t, i, 0), n = !$e5ed8027d647799b$var$r(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $e5ed8027d647799b$var$P(this, e[s + l], i, l), h === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$e5ed8027d647799b$var$r(h) || h !== this._$AH[l]), h === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.k(t);
    }
    k(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class $e5ed8027d647799b$var$M extends $e5ed8027d647799b$var$S {
    constructor(){
        super(...arguments), this.type = 3;
    }
    k(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
const $e5ed8027d647799b$var$k = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$S {
    constructor(){
        super(...arguments), this.type = 4;
    }
    k(t) {
        t && t !== $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $e5ed8027d647799b$var$k) : this.element.removeAttribute(this.name);
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$S {
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $e5ed8027d647799b$var$P(this, t, i, 0)) && void 0 !== s ? s : $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $e5ed8027d647799b$export$45b790e32b2810ee && e !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (e === $e5ed8027d647799b$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$P(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    P: "$lit$",
    V: $e5ed8027d647799b$var$e,
    L: $e5ed8027d647799b$var$o,
    I: 1,
    N: $e5ed8027d647799b$var$C,
    R: $e5ed8027d647799b$var$V,
    D: $e5ed8027d647799b$var$u,
    j: $e5ed8027d647799b$var$P,
    H: $e5ed8027d647799b$var$N,
    O: $e5ed8027d647799b$var$S,
    F: $e5ed8027d647799b$var$H,
    B: $e5ed8027d647799b$var$I,
    W: $e5ed8027d647799b$var$M,
    Z: $e5ed8027d647799b$var$L
}, $e5ed8027d647799b$var$z = window.litHtmlPolyfillSupport;
null == $e5ed8027d647799b$var$z || $e5ed8027d647799b$var$z($e5ed8027d647799b$var$E, $e5ed8027d647799b$var$N), (null !== ($e5ed8027d647799b$var$t = globalThis.litHtmlVersions) && void 0 !== $e5ed8027d647799b$var$t ? $e5ed8027d647799b$var$t : globalThis.litHtmlVersions = []).push("2.1.3");


// @ts-check
let $583bce5f07860537$var$reRenderFunction = null;
const $583bce5f07860537$export$f4f57181b4d5624 = (cb)=>$583bce5f07860537$var$reRenderFunction = cb;
const $583bce5f07860537$export$2e85ac34ab1128d8 = ()=>$583bce5f07860537$var$reRenderFunction();
const $583bce5f07860537$export$113a887360c6f0b7 = (filename, text)=>{
    const element = document.createElement("a");
    element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};
const $583bce5f07860537$export$b6169303db3deeb0 = ()=>{
    const element = document.createElement("input");
    function cleanUp() {
        element.removeEventListener("change", handleFile, true);
        element.remove();
    }
    function handleFile(e) {
        return new Promise((resolve, reject)=>{
            const file = e.target?.files?.[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (ev)=>{
                    const content = ev.target.result;
                    try {
                        const jsonContent = JSON.parse(content);
                        cleanUp();
                        resolve(jsonContent);
                    } catch (error) {
                        cleanUp();
                        reject(error);
                    }
                };
                reader.readAsText(file);
            } else {
                cleanUp();
                reject("no file");
            }
        });
    }
    return new Promise((resolve, reject)=>{
        element.setAttribute("type", "file");
        element.setAttribute("accept", "application/JSON");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        element.addEventListener("change", (e)=>handleFile(e).then(resolve).catch(reject), true);
    });
};


// @ts-check
// @ts-check
const $5cdc329eeebd56d0$export$8f45430ccf837300 = [
    "red",
    "blue",
    "black",
    "pink",
    "green",
    "yellow"
];
const $5cdc329eeebd56d0$export$7e3df82ee760448c = 16;
const $5cdc329eeebd56d0$export$ac607276a8fe9f0a = 16;
const $5cdc329eeebd56d0$export$9ad978cfcc58e76b = [];
for(let x = 0; x <= $5cdc329eeebd56d0$export$7e3df82ee760448c; x++){
    const row = [];
    for(let y = 0; y <= $5cdc329eeebd56d0$export$ac607276a8fe9f0a; y++)row.push({
        posName: `pos-${x}-${y}`
    });
    $5cdc329eeebd56d0$export$9ad978cfcc58e76b.push(row);
}




// @ts-check
const $2ad2279805e583d1$var$store = {
    selectedColor: "red",
    pos: {}
};
function $2ad2279805e583d1$export$fa23577ed00dcf0e(value) {
    if (value?.pos) $2ad2279805e583d1$var$store.pos = value.pos;
}
var $2ad2279805e583d1$export$2e2bcd8739ae039 = $2ad2279805e583d1$var$store;


const $16ef318e25301f3f$var$setColor = (colorName)=>{
    (0, $2ad2279805e583d1$export$2e2bcd8739ae039).selectedColor = colorName;
    (0, $583bce5f07860537$export$2e85ac34ab1128d8)();
};
const $16ef318e25301f3f$var$selectedColor = ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="selected-color ${(0, $2ad2279805e583d1$export$2e2bcd8739ae039).selectedColor}">
    Selected color: ${(0, $2ad2279805e583d1$export$2e2bcd8739ae039).selectedColor}
  </div>
`;
const $16ef318e25301f3f$var$colorSpan = (color)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <span class="color ${color}" @click=${()=>$16ef318e25301f3f$var$setColor(color)}>${color}</span>
`;
const $16ef318e25301f3f$var$controlColors = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="colors">
    ${(0, $5cdc329eeebd56d0$export$8f45430ccf837300).map((color)=>$16ef318e25301f3f$var$colorSpan(color))}
  </div>
`;
const $16ef318e25301f3f$var$saveFile = ()=>{
    (0, $583bce5f07860537$export$113a887360c6f0b7)("brixit-file.json", JSON.stringify((0, $2ad2279805e583d1$export$2e2bcd8739ae039)));
};
const $16ef318e25301f3f$var$loadFile = ()=>{
    (0, $583bce5f07860537$export$b6169303db3deeb0)().then((data)=>{
        (0, $2ad2279805e583d1$export$fa23577ed00dcf0e)(data);
        (0, $583bce5f07860537$export$2e85ac34ab1128d8)();
    }).catch(alert);
};
const $16ef318e25301f3f$var$cleanStore = ()=>{
    (0, $2ad2279805e583d1$export$fa23577ed00dcf0e)({
        pos: {}
    });
    (0, $583bce5f07860537$export$2e85ac34ab1128d8)();
};
const $16ef318e25301f3f$var$options = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="options">
    <button @click=${()=>$16ef318e25301f3f$var$loadFile()}>Load</button>
    <button @click=${()=>$16ef318e25301f3f$var$saveFile()}>Save</button>
    <button @click=${()=>$16ef318e25301f3f$var$cleanStore()}>Clear</button>
  </div>
`;
const $16ef318e25301f3f$var$drawControls = ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="controls">
    ${$16ef318e25301f3f$var$selectedColor()} ${$16ef318e25301f3f$var$controlColors} ${$16ef318e25301f3f$var$options}
  </div>
`;
var $16ef318e25301f3f$export$2e2bcd8739ae039 = $16ef318e25301f3f$var$drawControls;


// @ts-check




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3baabda811939da5$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $3baabda811939da5$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $3baabda811939da5$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { H: $ead5767561d7cbc1$var$i } = (0, $e5ed8027d647799b$export$8613d1ca9052b22e), $ead5767561d7cbc1$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $ead5767561d7cbc1$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $ead5767561d7cbc1$export$6b6d145ec2a44ca9 = (o, i)=>{
    var t, n;
    return void 0 === i ? void 0 !== (null === (t = o) || void 0 === t ? void 0 : t._$litType$) : (null === (n = o) || void 0 === n ? void 0 : n._$litType$) === i;
}, $ead5767561d7cbc1$export$2f448fec17d50a3e = (o)=>{
    var i;
    return void 0 !== (null === (i = o) || void 0 === i ? void 0 : i._$litDirective$);
}, $ead5767561d7cbc1$export$f28e31de6a6eaf32 = (o)=>{
    var i;
    return null === (i = o) || void 0 === i ? void 0 : i._$litDirective$;
}, $ead5767561d7cbc1$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $ead5767561d7cbc1$var$e = ()=>document.createComment(""), $ead5767561d7cbc1$export$291b2338ad9b0b30 = (o, t, n)=>{
    var v;
    const l = o._$AA.parentNode, d = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === n) {
        const t = l.insertBefore($ead5767561d7cbc1$var$e(), d), v = l.insertBefore($ead5767561d7cbc1$var$e(), d);
        n = new $ead5767561d7cbc1$var$i(t, v, o, o.options);
    } else {
        const i = n._$AB.nextSibling, t = n._$AM, r = t !== o;
        if (r) {
            let i;
            null === (v = n._$AQ) || void 0 === v || v.call(n, o), n._$AM = o, void 0 !== n._$AP && (i = o._$AU) !== t._$AU && n._$AP(i);
        }
        if (i !== d || r) {
            let o = n._$AA;
            for(; o !== i;){
                const i = o.nextSibling;
                l.insertBefore(o, d), o = i;
            }
        }
    }
    return n;
}, $ead5767561d7cbc1$export$cb8bf9562088e9f4 = (o, i, t = o)=>(o._$AI(i, t), o), $ead5767561d7cbc1$var$f = {}, $ead5767561d7cbc1$export$ea70d9dd5965b1c8 = (o, i = $ead5767561d7cbc1$var$f)=>o._$AH = i, $ead5767561d7cbc1$export$59e9bce518cde500 = (o)=>o._$AH, $ead5767561d7cbc1$export$3133b3144bbba267 = (o)=>{
    var i;
    null === (i = o._$AP) || void 0 === i || i.call(o, !1, !0);
    let t = o._$AA;
    const n = o._$AB.nextSibling;
    for(; t !== n;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $ead5767561d7cbc1$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e41d1b66de65ecc4$var$u = (e, s, t)=>{
    const r = new Map;
    for(let l = s; l <= t; l++)r.set(e[l], l);
    return r;
}, $e41d1b66de65ecc4$export$76d90c956114f2c2 = (0, $3baabda811939da5$export$99b43ad1ed32e735)(class extends (0, $3baabda811939da5$export$befdefbdce210f91) {
    constructor(e){
        if (super(e), e.type !== (0, $3baabda811939da5$export$9ba3b3f20a85bfa).CHILD) throw Error("repeat() can only be used in text expressions");
    }
    dt(e, s, t) {
        let r;
        void 0 === t ? t = s : void 0 !== s && (r = s);
        const l = [], o = [];
        let i = 0;
        for (const s of e)l[i] = r ? r(s, i) : i, o[i] = t(s, i), i++;
        return {
            values: o,
            keys: l
        };
    }
    render(e, s, t) {
        return this.dt(e, s, t).values;
    }
    update(s, [t, r, c]) {
        var d;
        const a = (0, $ead5767561d7cbc1$export$59e9bce518cde500)(s), { values: p, keys: v } = this.dt(t, r, c);
        if (!Array.isArray(a)) return this.at = v, p;
        const h = null !== (d = this.at) && void 0 !== d ? d : this.at = [], m = [];
        let y, x, j = 0, k = a.length - 1, w = 0, A = p.length - 1;
        for(; j <= k && w <= A;)if (null === a[j]) j++;
        else if (null === a[k]) k--;
        else if (h[j] === v[w]) m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[j], p[w]), j++, w++;
        else if (h[k] === v[A]) m[A] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[k], p[A]), k--, A--;
        else if (h[j] === v[A]) m[A] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[j], p[A]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, m[A + 1], a[j]), j++, A--;
        else if (h[k] === v[w]) m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(a[k], p[w]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j], a[k]), k--, w++;
        else if (void 0 === y && (y = $e41d1b66de65ecc4$var$u(v, w, A), x = $e41d1b66de65ecc4$var$u(h, j, k)), y.has(h[j])) {
            if (y.has(h[k])) {
                const e = x.get(v[w]), t = void 0 !== e ? a[e] : null;
                if (null === t) {
                    const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j]);
                    (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[w]), m[w] = e;
                } else m[w] = (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(t, p[w]), (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, a[j], t), a[e] = null;
                w++;
            } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(a[k]), k--;
        } else (0, $ead5767561d7cbc1$export$3133b3144bbba267)(a[j]), j++;
        for(; w <= A;){
            const e = (0, $ead5767561d7cbc1$export$291b2338ad9b0b30)(s, m[A + 1]);
            (0, $ead5767561d7cbc1$export$cb8bf9562088e9f4)(e, p[w]), m[w++] = e;
        }
        for(; j <= k;){
            const e = a[j++];
            null !== e && (0, $ead5767561d7cbc1$export$3133b3144bbba267)(e);
        }
        return this.at = v, (0, $ead5767561d7cbc1$export$ea70d9dd5965b1c8)(s, m), $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
});



const $679ca87cafb56c94$var$togglePosColor = (posName)=>{
    if (!(0, $2ad2279805e583d1$export$2e2bcd8739ae039).pos[posName]) (0, $2ad2279805e583d1$export$2e2bcd8739ae039).pos[posName] = (0, $2ad2279805e583d1$export$2e2bcd8739ae039).selectedColor;
    else (0, $2ad2279805e583d1$export$2e2bcd8739ae039).pos[posName] = "";
};
const $679ca87cafb56c94$var$clickHandler = (posName)=>{
    $679ca87cafb56c94$var$togglePosColor(posName);
    (0, $583bce5f07860537$export$2e85ac34ab1128d8)();
};
document.addEventListener("dragover", function(event) {
    event.preventDefault();
    if (event.target.dataset.posname) {
        (0, $2ad2279805e583d1$export$2e2bcd8739ae039).pos[event.target.dataset.posname] = (0, $2ad2279805e583d1$export$2e2bcd8739ae039).selectedColor;
        (0, $583bce5f07860537$export$2e85ac34ab1128d8)();
    }
}, false);
const $679ca87cafb56c94$var$getColor = (posName)=>(0, $2ad2279805e583d1$export$2e2bcd8739ae039).pos[posName] || "";
// templates
const $679ca87cafb56c94$var$cellSpan = (cell)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <span
    class="cell ${$679ca87cafb56c94$var$getColor(cell.posName)}"
    @click=${()=>$679ca87cafb56c94$var$clickHandler(cell.posName)}
    data-posname="${cell.posName}"
    draggable="true"
  ></span>
`;
const $679ca87cafb56c94$var$rowDiv = (row)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="row">
    ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)(row, (cell)=>$679ca87cafb56c94$var$cellSpan(cell))}
  </div>
`;
const $679ca87cafb56c94$var$drawMatrix = ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="matrix">
    ${(0, $e41d1b66de65ecc4$export$76d90c956114f2c2)((0, $5cdc329eeebd56d0$export$9ad978cfcc58e76b), (row)=>$679ca87cafb56c94$var$rowDiv(row))}
  </div>
`;
var $679ca87cafb56c94$export$2e2bcd8739ae039 = $679ca87cafb56c94$var$drawMatrix;


const $b63be9b0371e788c$var$header = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <h1>BRIXIT</h1>
`;
const $b63be9b0371e788c$var$footer = (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  <div class="container">Made by Alireza Balouch with lit-html and parcel.</div>
  <div class="container"><a href="https://github.com/swape/brixit" target="_blank" rel="noopener">github.com/swape/brixit</a>
  </div>`;
const $b63be9b0371e788c$var$myTemplate = ()=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
  ${$b63be9b0371e788c$var$header}
  <div class="container">${(0, $679ca87cafb56c94$export$2e2bcd8739ae039)()}${(0, $16ef318e25301f3f$export$2e2bcd8739ae039)()}</div>
  ${$b63be9b0371e788c$var$footer}
`;
const $b63be9b0371e788c$var$body = document.body;
(0, $583bce5f07860537$export$f4f57181b4d5624)(()=>(0, $e5ed8027d647799b$export$b3890eb0ae9dca99)($b63be9b0371e788c$var$myTemplate(), $b63be9b0371e788c$var$body));
(0, $583bce5f07860537$export$2e85ac34ab1128d8)();


//# sourceMappingURL=index.3129b8c8.js.map
